import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'common/components/Icon';
import Button from 'common/components/Button';
import colors from 'common/styles/colors';

import Typography from 'common/components/Typography';
import styles from './index.module.css';

const BalanceCard = ({ balance }) => (
  <div className={styles.root}>
    <div className={styles.content}>
      <div className={styles.header}>
        <Icon.WalletDuotone
          description="Wallet icon"
          size="medium"
          fill={colors['rebranding-md-color-brand-purple']}
        />
        <Typography
          tag="h2"
          size="base"
          weight="semiBold"
          color="color-neutral-900"
        >
          Balance
        </Typography>
      </div>
      <div className={styles.balanceSection}>
        <Typography
          tag="div"
          size="xl"
          weight="semiBold"
          color="color-neutral-900"
        >
          {balance.totalSettlement}
        </Typography>
        <div className={styles.xmnBalance}>
          <span className={styles.equalsSign}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM4.66699 10H10V8.66699H4.66699V10ZM6 6V7.33301H11.333V6H6Z"
                fill="#7C4DFF"
              />
            </svg>
          </span>
          <Typography tag="div" size="base" color="color-neutral-900">
            {balance.totalXmn}
          </Typography>
        </div>
      </div>
      <div className={styles.balanceDetails}>
        <div className={styles.balanceItem}>
          <div className={styles.balanceItemHeader}>
            <Icon.Lock2Duotone
              className={styles.lockedIcon}
              description="Locked"
              size="xxSmall"
              fill={colors['color-yellow-500']}
            />
            <Typography
              tag="div"
              size="xs"
              weight="semiBold"
              color="color-neutral-500"
            >
              Locked
            </Typography>
          </div>
          <Typography
            tag="div"
            size="lg"
            weight="semiBold"
            color="color-neutral-900"
          >
            {balance.locked.xmn}
          </Typography>
          <Typography tag="div" size="xs" color="color-neutral-900">
            {balance.locked.settlement}
          </Typography>
        </div>
        <div className={styles.balanceItem}>
          <div className={styles.balanceItemHeader}>
            <Icon.Lock2OpenedDuotone
              className={styles.unlockedIcon}
              description="Unlocked"
              size="xxSmall"
              fill={colors['color-green-900']}
            />
            <Typography
              tag="div"
              size="xs"
              weight="semiBold"
              color="color-neutral-500"
            >
              Unlocked
            </Typography>
          </div>
          <Typography
            tag="div"
            size="lg"
            weight="semiBold"
            color="color-neutral-900"
          >
            {balance.unlocked.xmn}
          </Typography>
          <Typography tag="div" size="xs" color="color-neutral-900">
            {balance.unlocked.settlement}
          </Typography>
          <div className={styles.withdrawButtonContainer}>
            <Button kind="primary" full disabled>
              <button type="button">Withdraw rewards</button>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

BalanceCard.propTypes = {
  balance: PropTypes.shape({
    totalSettlement: PropTypes.string.isRequired,
    totalXmn: PropTypes.string.isRequired,
    locked: PropTypes.shape({
      xmn: PropTypes.string.isRequired,
      settlement: PropTypes.string.isRequired,
    }).isRequired,
    unlocked: PropTypes.shape({
      xmn: PropTypes.string.isRequired,
      settlement: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default BalanceCard;
